import { ComponentProps, FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { TextInput } from '@telialt/common-text-input/src';

import { EMAIL_VALIDATION_PATTERN } from './constants';

type Props = Omit<ComponentProps<typeof TextInput>, 'type'>;

export const EmailInput: FC<Props> = (props) => {
    const { t } = useTranslations();

    return (
        <TextInput
            type="email"
            pattern={EMAIL_VALIDATION_PATTERN.source}
            patternErrorMessage={t['common.email_input.pattern_error']}
            {...props}
        />
    );
};
